import { useState } from 'react';
import { truncateRichContent } from '@wix/ricos';
export function useTruncateRicosContent(content, maxShownParagraphs) {
  const [isTruncated, setIsTruncated] = useState(true);
  function toggleTruncate() {
    setIsTruncated(prevState => !prevState);
  }
  return {
    displayedContent: maxShownParagraphs && isTruncated ? truncateRichContent(content, {
      nodeCount: maxShownParagraphs
    }) : content,
    isTruncated: maxShownParagraphs ? isTruncated : false,
    isTruncateButtonShown: maxShownParagraphs ? content.nodes.length > maxShownParagraphs : false,
    toggleTruncate
  };
}
//# sourceMappingURL=use-truncate-ricos-content.js.map